import SeoLandingLayout from './components/SeoLandingLayout';

export default function NutricionistaPalmaPage() {
  return (
    <SeoLandingLayout
      title="Nutricionista y Dietista en Palma de Mallorca | Dario Rojas"
      description="Consulta con Dario Rojas, nutricionista y dietista en Palma de Mallorca. Planes personalizados para mejorar habitos y salud."
      canonicalPath="/nutricionista-palma-de-mallorca"
      heading="Nutricionista y dietista en Palma de Mallorca"
      intro="Si buscas un nutricionista en Palma de Mallorca para mejorar tu alimentacion, perder grasa o cuidar tu salud digestiva, trabajo contigo con un plan realista y sostenible."
      bullets={[
        'Evaluacion inicial completa y objetivos claros',
        'Plan de alimentacion personalizado para tu rutina',
        'Educacion nutricional para mantener resultados',
        'Seguimiento continuo para ajustar el plan',
      ]}
      sections={[
        {
          title: 'Consulta de nutricion personalizada en Palma',
          paragraphs: [
            'Cada consulta parte de tu situacion actual, tus analiticas, tus horarios y tus objetivos. La idea es que tengas un plan claro, aplicable y facil de mantener en el tiempo.',
            'Trabajo tanto con objetivos de composicion corporal como con mejora de habitos, rendimiento diario y salud digestiva. El seguimiento permite adaptar el plan segun tu evolucion.',
          ],
        },
        {
          title: 'Por que elegir un nutricionista local',
          paragraphs: [
            'Un nutricionista en Palma conoce el contexto real de tu estilo de vida, horarios, restaurantes y opciones de compra habituales. Eso permite recomendaciones mas realistas.',
            'Mi enfoque no se basa en dietas cerradas, sino en estrategias personalizadas para que aprendas a comer mejor sin depender de menus rigidos.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'Cuanto dura la primera consulta de nutricion en Palma?',
          answer:
            'La primera consulta suele durar entre 45 y 60 minutos, segun tu caso y objetivos.',
        },
        {
          question: 'Ofreces seguimiento despues de la evaluacion inicial?',
          answer:
            'Si. El seguimiento es clave para ajustar el plan, resolver dudas y consolidar resultados.',
        },
        {
          question: 'Atiendes de forma presencial u online?',
          answer:
            'Atiendo en Palma de Mallorca y tambien en formato online para mayor flexibilidad.',
        },
      ]}
      schema={[
        {
          '@context': 'https://schema.org',
          '@type': 'MedicalBusiness',
          name: 'Dario Rojas Nutricion',
          image:
            'https://vhnuplacedgmgryjrjhn.supabase.co/storage/v1/object/public/cms-images/perfil.jpg',
          url: 'https://dariorojasnutricion.es/nutricionista-palma-de-mallorca',
          telephone: '+34 685546738',
          email: 'dariorojasnutricion@gmail.com',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Palma de Mallorca',
            addressRegion: 'Islas Baleares',
            addressCountry: 'ES',
          },
          areaServed: 'Palma de Mallorca',
          openingHours: 'Mo-Fr 09:00-18:00',
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Consulta de nutricion en Palma de Mallorca',
          serviceType: 'Nutricion y dietetica personalizada',
          areaServed: 'Palma de Mallorca',
          provider: {
            '@type': 'Person',
            name: 'Dario Rojas',
            jobTitle: 'Nutricionista y Dietista',
          },
          url: 'https://dariorojasnutricion.es/nutricionista-palma-de-mallorca',
        },
      ]}
    />
  );
}
